import React, { useEffect, useState } from "react";
import { API } from "../../Redux/actions/API";
import { useNavigate } from "react-router-dom";
import Table from "../Table/Table";
import Navbar from "../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import { toast } from "react-toastify";

export default function News() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [content, setcontent] = useState("");
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);

  const referral_API = async () => {
    try {
      let responceRight = await API?.post(
        "/newsAdmin",
        {
          loginid: userId,
          id: 0,
          content: "",
          type: 1,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      //console.log("ewalletDetails", responceRight?.data?.data);
      responceRight = responceRight?.data?.data.data[0];
      setleftreferralApi([]);
      let arrayLeft = [];

      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: item.row,
          content: item.content,
          edate: `${item?.dd}`,
          delete: (
            <>
              <input
                type="button"
                id="btnsearch"
                onClick={() => DeleteUPI_API(item.id)}
                className="btn btn-sm btn-primary"
                value="Delete"
              />
            </>
          ),
        });
      });
      setleftreferralApi(arrayLeft);
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const OnhandleSubmit_API = async () => {
    try {
      let responceRight = await API?.post(
        `newsAdmin`,
        {
          loginid: userId,
          id: 0,
          content: content,
          type: 3,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      //console.log("submit", responceRight?.data?.data);
      //console.log("response", responceRight?.data?.data[0][0]);
      //responceRight = responceRight?.data?.data[0][0];
      if (responceRight?.data?.data.result.result == "success") {
        toast.success("News Added Successfully !!");
        referral_API();
        setcontent("");
      } else {
        toast.error(responceRight?.data?.data.result.result);
      }
    } catch (e) {
      console.log("error directdeposite APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "" }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const DeleteUPI_API = async (RowId) => {
    try {
      let responceRight = await API?.post(
        `newsAdmin`,
        {
          loginid: userId,
          id: RowId,
          content: "",
          type: 4,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      console.log("submit", responceRight?.data?.data);

      if (responceRight?.data?.data.result.result == "success") {
        toast.success("Deleted Successfully !!");
        setcontent("");
        referral_API();
      } else {
        toast.error(responceRight?.data?.data.result.result);
      }
    } catch (e) {
      console.log("error directdeposite APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "" }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;

  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "News Content", accessor: "content" },
      { Header: "Date", accessor: "edate" },
      { Header: "Delete", accessor: "delete" },
    ],
  });

  return (
    <div>
      <Navbar />
      <div className="content-page">
        <div className="content">
          {/* <!-- Inline Form --> */}
          <div className="row">
            <div className="col-md-12">
              <div className="panel panel-primary">
                <div className="panel-heading">
                  <h4 className="panel-title"> Add News</h4>
                </div>
                <div
                  className="panel-body table-rep-plugin"
                  style={{ padding: "8px", overflowY: "scroll" }}
                >
                  <div className="col-md-12">
                    <>
                      {" "}
                      <div className="row mb-5">
                        <form>
                          <div className="col-sm-4">
                            <input
                              className="form-control in-ip-1"
                              id="upiid"
                              onChange={(e) => setcontent(e.target.value)}
                              name="upiid"
                              placeholder="Enter News Content.."
                              type="text"
                              value={content}
                              maxLength={100}
                            />
                          </div>

                          <div className="col-sm-1">
                            <input
                              type="button"
                              id="btnsearch"
                              onClick={() => OnhandleSubmit_API()}
                              className="btn btn-sm btn-primary"
                              value="Add"
                            />
                          </div>
                        </form>
                      </div>
                    </>
                    <div className="row panel panel-primary">
                      <div className="panel-heading">
                        <h4 className="panel-title"> USDT QR Details</h4>
                      </div>
                      <div
                        className="table-responsive"
                        data-pattern="priority-columns"
                        style={{ maxHeight: "500px", overflow: "scroll" }}
                      >
                        <Table data={currentPostleft} columns={my_team.cols} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
